/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Min_Frame_GapInputs */



/**
* | output |
* | --- |
* | "Min. Frame Gap" |
*
* @param {Options_Editor_Min_Frame_GapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_min_frame_gap = /** @type {((inputs?: Options_Editor_Min_Frame_GapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Min_Frame_GapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Écart min. en images")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestrahmenabstand")
	if (locale === "it") return /** @type {LocalizedString} */ ("Distanza minima tra i telai")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальный зазор между кадрами")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espacio mínimo entre marcos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最小帧间隙")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最小フレームギャップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("न्यूनतम फ्रेम अंतर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Espaço mínimo entre quadros")
	return /** @type {LocalizedString} */ ("Min. Frame Gap")
});